import axios from "axios";
import AppData from "../config/appData.json";

const api = axios.create({
  baseURL: AppData.API_BASE_URL, // Use dynamic base URL from config
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Attach dynamic headers before each request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const serialNumber = localStorage.getItem("serialNumber");

  config.headers["channel"] = AppData.CHANNEL_NAME || "defaultChannel";

  if (serialNumber) {
    config.headers["ddsn"] = serialNumber;
  }

  if (token && !config.url.includes("auth/get-token")) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});

// Function to determine and store user type
const storeUserType = (userData) => {
  if (userData?.adminType) {
    localStorage.setItem("userType", "admin");
  } else {
    localStorage.setItem("userType", "user");
  }
};

// Response interceptor for global response handling
api.interceptors.response.use(
  (response) => {
    const { data } = response;

    if (data) {
      if (data.userData) {
        storeUserType(data.userData);
      }
      if (data.token) {
        localStorage.setItem("token", data.token);
      }
      if (data.data?.token) {
        localStorage.setItem("token", data.data.token);
      }
    }

    return data; // Return only the response data
  },
  (error) => {
    console.error("API Error:", error?.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Function to send a POST request
export const postData = async (url, data) => {
  try {
    let token = localStorage.getItem("token");

    if (!token && url !== AppData.VAS_URL + "auth/get-token") {
      console.warn("Token not found. Login might be required.");
      throw new Error("Authentication token missing. Please log in again.");
    }

    const response = await api({
      method: "post",
      url,
      data,
    });
    return response;
  } catch (error) {
    console.error(
      "Post Request Failed:",
      error?.response?.data || error.message
    );
    throw error;
  }
};

export default api;
